import clsx from 'clsx';
import React from 'react';

import AiIcon from 'common/shared-ui/src/icons/AiIcon';
import { useAppSelector } from 'components/app/redux/store';

import styles from './styles.module.css';

type Props = {
  readonly onClick: () => void;
};

export const Activator: React.FC<Props> = props => {
  const { aiButton } = useAppSelector(
    state => state.localization.components.ChatBot.messages,
  );

  return (
    <button className={clsx(styles.button)} onClick={props.onClick}>
      <AiIcon />
      <span>{aiButton}</span>
    </button>
  );
};
